import React from 'react';
import { Box, Typography, TextField, Grid, Avatar } from '@mui/material';
import useAuthProviderStore from '../../stores/auth_provider.store';

function ProfileTab() {
  const { graphProfile, profilePic } = useAuthProviderStore((state) => ({
    graphProfile: state.graphProfile,
    profilePic: state.profilePic,
  }));

  return (
    <Box>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" fontWeight={600} gutterBottom>
          Profile Information
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Update your personal details and company information
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', mb: 4 }}>
        {profilePic === null && (
          <Avatar sx={{ width: 80, height: 80, bgcolor: 'primary.main' }} />
        )}
        {profilePic === false && (
          <Avatar sx={{ width: 80, height: 80, bgcolor: 'primary.main' }}>
            <Typography variant="h4">{graphProfile?.nameInitials}</Typography>
          </Avatar>
        )}
        {profilePic && (
          <Avatar src={profilePic} sx={{ width: 80, height: 80 }} />
        )}
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle2" gutterBottom fontWeight={600}>
            Full Name
          </Typography>
          <TextField
            fullWidth
            value={graphProfile?.displayName || ''}
            InputProps={{
              readOnly: true,
            }}
            variant="outlined"
            size="small"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle2" gutterBottom fontWeight={600}>
            Email Address
          </Typography>
          <TextField
            fullWidth
            value={graphProfile?.mail || ''}
            InputProps={{
              readOnly: true,
            }}
            variant="outlined"
            size="small"
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default ProfileTab;
